import { Grid } from "@mui/material";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Fragment, useEffect, useState } from "react";

import pages from "../../constants/pages";
import List from "./audience list components/List";
import { useAxios, useComponent } from "../../hooks";
import { PrimaryButton } from "../css components/Button";
import { PageHeader, Pagination } from "../../components";
import { getAllAudiences } from "./create audience components/audienceObjects";
import queryString from "query-string";

export default function AudienceList() {
  const axios = useAxios();
  const navigate = useNavigate();
  const { loader } = useComponent();

  const [loading, setLoading] = useState(false);
  const [searchKey, setSearchKey] = useState("");
  const [audiences, setAudiences] = useState([]);
  const [page, setPage] = useState({
    page: 1,
    totalCount: 0,
    lastCount: 0,
    itemsPerPage: 10,
  });

  const brandID =
    useSelector((state) => state.memberDetails?.activeBrand?.ID) ||
    queryString.parse(window.location.search).brandID;

  useEffect(() => {
    setLoading(true);

    axios({
      url:
        "/brand/getAllAudiences?brandId=" +
        brandID +
        `&page=${page.page}&limit=${page.itemsPerPage}` +
        (searchKey ? `&search=${encodeURIComponent(searchKey)}` : ""),
    }).then((response) => {
      if (response.status) {
        if (response.data.audienceData.length > 0) {
          setPage((prev) => ({
            ...prev,
            totalCount: response.data.totalCounts,
            lastPage: response.data.campaignData?.length < 10,
          }));

          setAudiences(getAllAudiences(response));
        } else {
          setAudiences([]);
        }
      }
      setLoading(false);
    });
  }, [axios, brandID, loader, page.page, searchKey, page.itemsPerPage]);

  function handlePagination(step, index) {
    setPage((prev) => ({
      ...prev,
      page: step === "index" ? index : prev + (step === "next" ? 1 : -1),
    }));
  }

  return (
    <Fragment>
      <PageHeader
        pageName={"Audiences"}
        pageHeader="View and manage your saved audiences for targeted campaigns."
        buttons={[
          <PrimaryButton
            variant="contained"
            onClick={() => navigate(pages.createAudience.route + "?mode=edit")}
          >
            Create Audience
          </PrimaryButton>,
        ]}
      />

      <List
        audiences={audiences}
        loading={loading}
        setPage={setPage}
        setSearchKey={setSearchKey}
        component=""
      />

      {!!page.totalCount && (
        <Grid
          item
          container
          marginTop={"10px"}
          display={"flex"}
          justifyContent={"center"}
        >
          <Pagination
            count={Math.ceil(page.totalCount / 10)}
            variant="outlined"
            color="secondary"
            page={page.page}
            onChange={(e, value) => handlePagination("index", value)}
          />
        </Grid>
      )}
    </Fragment>
  );
}
